// Onboarding profile fields captured in CompleteProfile (beyond business type).

export const INDUSTRY_OTHER = 'other';

export const INDUSTRIES = Object.freeze([
  { value: 'agriculture_farming', label: 'Agriculture / farming' },
  { value: 'forestry_land', label: 'Forestry / land management' },
  { value: 'food_supply_chain', label: 'Food & drink / supply chain' },
  { value: 'environmental_consultancy', label: 'Environmental consultancy' },
  { value: 'esg_finance', label: 'ESG / sustainability / finance' },
  { value: 'government_public', label: 'Government / public sector' },
  { value: 'academia_research', label: 'Academia / research' },
  { value: 'ngo_charity', label: 'NGO / charity / land trust' },
  { value: 'property_land_investment', label: 'Property / land investment' },
  { value: INDUSTRY_OTHER, label: 'Other (please specify)' },
]);

export const BUSINESS_SIZES = Object.freeze([
  { value: 'solo', label: 'Just me (sole trader / self-employed)' },
  { value: '2_10', label: '2-10 people' },
  { value: '11_50', label: '11-50 people' },
  { value: '51_250', label: '51-250 people' },
  { value: '251_1000', label: '251-1,000 people' },
  { value: '1000_plus', label: 'More than 1,000 people' },
  { value: 'prefer_not_to_say', label: 'Prefer not to say' },
]);

export const REFERRAL_SOURCE_OTHER = 'other';

export const REFERRAL_SOURCES = Object.freeze([
  { value: 'search_engine', label: 'Search engine (Google, Bing, etc.)' },
  { value: 'social_media', label: 'Social media' },
  { value: 'word_of_mouth', label: 'Word of mouth / colleague' },
  { value: 'event_conference', label: 'Conference / event' },
  { value: 'partner_referral', label: 'Partner or referral' },
  { value: 'email_newsletter', label: 'Email or newsletter' },
  { value: 'press_article', label: 'Article or press' },
  { value: REFERRAL_SOURCE_OTHER, label: 'Other (please specify)' },
]);

const INDUSTRY_VALUES = new Set(INDUSTRIES.map((o) => o.value));
const BUSINESS_SIZE_VALUES = new Set(BUSINESS_SIZES.map((o) => o.value));
const REFERRAL_SOURCE_VALUES = new Set(REFERRAL_SOURCES.map((o) => o.value));

export function isValidIndustry(value) {
  return INDUSTRY_VALUES.has(value);
}

export function isValidBusinessSize(value) {
  return BUSINESS_SIZE_VALUES.has(value);
}

export function isValidReferralSource(value) {
  return REFERRAL_SOURCE_VALUES.has(value);
}
